// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js';
import ElementUi from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCropper from 'vue-cropper';
import 'babel-polyfill';
import Es6Promise from 'es6-promise';
import VueAMap from 'vue-amap';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import './assets/iconfont/iconfont.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

let options = {
  fullscreenEl: false
};
Vue.use(preview, options)

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    title: false,//    显示当前图片的标题
    scalable: true,//图片是否可翻转
    rotatable: true,//图片是否可旋转
    tooltip: true,//显示缩放百分比
    navbar: false,//显示缩略图导航
    loop: false,
    loading: false

  }
})

Es6Promise.polyfill();

Vue.component(VueCropper);

Vue.use(ElementUi);
Vue.use(VueAMap);
Vue.config.productionTip = false

//高亮
Vue.prototype.brightenKeyword = function (val, keyword) {
  val = val + '';
  if (val.indexOf(keyword) !== -1 && keyword !== '') {
    return val.replace(keyword, '<font color="#4C9FFF">' + keyword + '</font>')
  } else {
    return val
  }
}

VueAMap.initAMapApiLoader({
  //高德的key
  key: "258180adc92a16a8ba63876c86daa2f2",
  // 插件集合
  plugin: [
    "AMap.Autocomplete",// 输入提示插件
    "AMap.PlaceSearch",// POI搜索插件
    "AMap.Scale",// 右下角缩略图插件 比例尺
    "AMap.OverView",// 地图鹰眼插件
    "AMap.ToolBar",// 地图工具条
    "AMap.MapType",// 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor",// 编辑 折线多，边形
    "AMap.CircleEditor",// 圆形编辑器插件
    "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
    "AMap.Geocoder",// 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
    "AMap.AMapUI",// UI组件
  ],
  v: "1.4.4",
  uiVersion: "1.0" // 版本号
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js